import { Route, Switch as RRDSwitch, useRouteMatch } from 'react-router-dom';
import React from 'react';

import DiscountsList from './features/DiscountsList';
import NewDiscount from './features/NewDiscount';
import ExistingDiscount from './features/ExistingDiscount';

const Discounts = () => {
  const { path } = useRouteMatch();

  return (
    <RRDSwitch>
      <Route exact path={path}>
        <DiscountsList />
      </Route>
      <Route path={`${path}/new`}>
        <NewDiscount />
      </Route>
      <Route
        path={`${path}/:id`}
        render={({
          match: {
            params: { id },
          },
        }) => <ExistingDiscount id={id?.trim()} />}
      />
    </RRDSwitch>
  );
};

export default Discounts;
